import { useState } from 'react';
import { getMinutesAgo } from './../utils/dates';
import { useEffect } from 'react';


const Counter = ({ timestamp }) => {

  const [minutes, setMinutes] = useState(0)

  useEffect(() => {
    setMinutes(getMinutesAgo(timestamp))
    let interval = setInterval(() => {
      setMinutes(getMinutesAgo(timestamp))
    }, 1000);
    return () => clearInterval(interval)
  }, [timestamp])

  if (!isNaN(minutes)) return <>{minutes} Min/s</>
  return null
}

export default Counter;